import { validateStep } from './validation';

/**
 * Recursively decide whether a section holds anything the client typed.
 * Walks arrays and nested objects so beneficiary rows and address
 * sub-objects count.
 */
function anyTruthy(value) {
  if (value === null || value === undefined) return false;
  if (Array.isArray(value)) return value.some(anyTruthy);
  if (typeof value === 'object') {
    return Object.entries(value).some(([key, v]) => (
      // `country` is always seeded to USA, so on its own it is not a signal
      // that the client has started filling anything in.
      key !== 'country' && anyTruthy(v)
    ));
  }
  if (typeof value === 'boolean') return value;
  if (typeof value === 'number') return value !== 0;
  return String(value).trim().length > 0;
}

/**
 * Per-step sidebar status: 'complete' | 'partial' | 'empty'.
 *
 * A step is complete exactly when it passes its own validation, so the
 * sidebar can never disagree with the Next button.
 */
export function computeStepStatuses(steps, formData) {
  return steps.map((step) => {
    if (step.key === 'welcome' || step.key === 'review') return 'complete';
    if (validateStep(step.key, formData) === null) return 'complete';
    return anyTruthy(formData?.[step.key]) ? 'partial' : 'empty';
  });
}

export default computeStepStatuses;
